module.exports = __webpack_public_path__ + "img/packing-2.c0bc38cc.png";